module.exports = __webpack_public_path__ + "static/adam-0b622e2b788bd296bbf6e613fd5b8217.png";